/**
 * Route for `flat-fee-cpa-cpl-cpi-cps-cpc-revshare-hybrid-payou`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FlatFeeCpaCplCpiCpsCpcRevshareHybridPayouPage } from "../features/flat-fee-cpa-cpl-cpi-cps-cpc-revshare-hybrid-payou/FlatFeeCpaCplCpiCpsCpcRevshareHybridPayouPage";

export const flatFeeCpaCplCpiCpsCpcRevshareHybridPayouRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/flat-fee-cpa-cpl-cpi-cps-cpc-revshare-hybrid-payou",
	component: FlatFeeCpaCplCpiCpsCpcRevshareHybridPayouPage,
});

export default flatFeeCpaCplCpiCpsCpcRevshareHybridPayouRoute;
